import React from "react";
import {css, cx} from "@panda/css";

import {IIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

export const INFO_PANEL_ICON_SIZE = "6";
export const INFO_PANEL_ICON_WRAPPER_SIZE = "6";

interface IProps {
    className?: string;
    icon: React.ComponentType<IIcon>;
    heading: string;
    headingAs?: "h1" | "h2" | "div" | "p";
    subHeading: React.ReactNode;
    subHeadingAs?: "p" | "span";
    additionalContent?: React.ReactNode;
}

export const InfoPanel = (props: IProps) => {
    const {icon: Icon} = props;

    return (
        <div className={cx(infoPanel, props.className)}>
            <Icon
                className={icon}
                size={INFO_PANEL_ICON_SIZE}
                wrapperSize={INFO_PANEL_ICON_WRAPPER_SIZE}
                wrapperColor="var(--colors-primary)"
                wrapperType="circle"
            />
            <Text as={props.headingAs} align="center" variant="headline_5" mb={1}>
                {props.heading}
            </Text>
            <Text color="var(--colors-gray-700)" as={props.subHeadingAs} align="center" variant="body_copy_2">
                {props.subHeading}
            </Text>

            {props.additionalContent || null}
        </div>
    );
};

const infoPanel = css({
    backgroundColor: "#fff",
    position: "relative",
    padding: "4.8rem 1.6rem 3.2rem",
    flexDirection: "column",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 2
});

const icon = css({
    position: "absolute",
    top: 0,
    transform: "translateY(-50%)"
});
import React from "react";
import {css, cx} from "@panda/css";

import {IIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

export const INFO_PANEL_ICON_SIZE = "6";
export const INFO_PANEL_ICON_WRAPPER_SIZE = "6";

interface IProps {
    className?: string;
    icon: React.ComponentType<IIcon>;
    heading: string;
    headingAs?: "h1" | "h2" | "div" | "p";
    subHeading: React.ReactNode;
    subHeadingAs?: "p" | "span";
    additionalContent?: React.ReactNode;
}

export const InfoPanel = (props: IProps) => {
    const {icon: Icon} = props;

    return (
        <div className={cx(infoPanel, props.className)}>
            <Icon
                className={icon}
                size={INFO_PANEL_ICON_SIZE}
                wrapperSize={INFO_PANEL_ICON_WRAPPER_SIZE}
                wrapperColor="var(--colors-primary)"
                wrapperType="circle"
            />
            <Text as={props.headingAs} align="center" variant="headline_5" mb={1}>
                {props.heading}
            </Text>
            <Text color="var(--colors-gray-700)" as={props.subHeadingAs} align="center" variant="body_copy_2">
                {props.subHeading}
            </Text>

            {props.additionalContent || null}
        </div>
    );
};

const infoPanel = css({
    backgroundColor: "#fff",
    position: "relative",
    padding: "4.8rem 1.6rem 3.2rem",
    flexDirection: "column",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 2
});

const icon = css({
    position: "absolute",
    top: 0,
    transform: "translateY(-50%)"
});
